import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import moment from 'moment';
import * as MySound from '../../MySound';
import RF_TransferDetails from '../RFTransfers/RF_TransferDetails';

export class RF_TransferHistory extends Component { 
    static displayName = RF_TransferHistory.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: false,
            namecode: "",
            selectedClient: "",
            startDate: new Date(),
            endDate: new Date(),
            docket: 0,
            rfStatus: "",
            transferRef: "",
            clients: [],
            rfTransfers: [],
            displayTransferLines: false,
            selectedRFTransfer: {}

        }
    }

    componentDidMount() {
        
        this.loadClients();
    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

     async loadClients() {
         var warehouseID = MyGlobal.warehouse;
         fetch(`api/Transfer/GetClients?warehouseId=${warehouseID}`)
             .then(async response => {

                 this.state.loading = false;
                 // check for error response
                 if (!response.ok) {
                     MySound.play(MySound.Sound.stop);
                     const errorText = await response.text();
                     this.setState({ alertMessage: "Failed to load Clients " + errorText });
                 }
                 else {
                     const isJson = response.headers.get('content-type')?.includes('application/json');
                     const apiResponse = isJson ? await response.json() : null;

                     if (apiResponse) {
                         const data = apiResponse.data;
                         if (apiResponse.success) {
                             this.setState({ clients: data });
                         }
                         else {
                             MySound.play(MySound.Sound.stop)
                             this.setState({ alertMessage: "Failed to load Clients" + apiResponse.errorMessage });
                         }
                     }
                     else {
                         MySound.play(MySound.Sound.stop)
                         this.setState({ alertMessage: "Failed to load Clients" });
                     }

                 }

             })
             .catch(error => {
                 MySound.play(MySound.Sound.stop)
                 this.setState({ clients: [], alertMessage: error });
             });
    }

    async loadTransferDetails() {

        if (this.state.namecode == "") {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please select a client" });
            return;
        }
        if (!this.state.startDate || !this.state.endDate) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please select both start and end dates" });
            return;
        }
        if (this.state.startDate > this.state.endDate) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Start date cannot be later than end date" });
            return;
        }

        this.state.loading = true;

        const getTransferHistoryRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Namecode: this.state.namecode,
                StartDate: this.state.startDate,
                EndDate: this.state.endDate,
               
            })
        };
        fetch('/api/Transfer/GetTransferHistory', getTransferHistoryRequest)
            .then(response => {
                console.log("Received response:", response);
                return response.json(); // Process the response to json
            })
            .then(data => {
                console.log("Processed data:", data);
                if (data.success) {
                    this.setState({ rfTransfers: data.data, alertMessage: "", loading: false });
                } else {
                    throw new Error(data.errorMessage || "Failed to load transfer history.");
                }
            })
            .catch(error => {
                console.error("Error loading transfer details:", error);
                MySound.play(MySound.Sound.stop);
                this.setState({ alertMessage: error.toString(), loading: false });
            });

    }
    handleDateChange = (field) => (selectedDate) => {
        this.setState({ [field]: selectedDate });
    }
    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Docket</th>
                        <th>Reference</th>
                        <th>RFStatus</th>
                        <th>Date Finalised</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => {
                        const formattedDateFinalised = row.dT_FINALISED
                            ? moment(row.dT_FINALISED).format('DD/MM/YYYY') 
                            : "Not Available";  

                        return (
                            <tr key={index} onClick={() => { this.showTransferLinesDisplay(row) }}> 
                                <td>{row.docket}</td>
                                <td>{row.reference}</td>
                                <td>{row.rfStatus}</td>
                                <td>{formattedDateFinalised}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    hideTransferLinesDisplay() {
        this.setState({ displayTransferLines: false });
    }
    showTransferLinesDisplay(selectedItem) {

        this.setState({ selectedRFTransfer: selectedItem, displayTransferLines: true })
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let rfTransfers = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.rfTransfers);

        let displayTransferLinesPrompt = this.state.displayTransferLines;
        displayTransferLinesPrompt = displayTransferLinesPrompt === true ? <RF_TransferDetails show={this.state.displayTransferLines} selectedClient={ this.state.selectedClient} rfTransfer={this.state.selectedRFTransfer} onClickClose={() => { this.hideTransferLinesDisplay(); }}  ></RF_TransferDetails > : "";


        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../Transfer'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label>Client :</label>
                        </Col>
                        <Col xs={9}>
                            <select
                                className="form-select form-control"
                                aria-label=".form-select-lg example"
                                value={this.state.namecode}
                                onChange={(e) => {
                                    const selectedClient = this.state.clients.find(client => client.namecode === e.target.value);
                                    this.setState({ namecode: e.target.value, selectedClient: selectedClient.name });
                                }}>
                                <option value="" disabled> Select a client </option>
                                {this.state.clients.map(client =>
                                    <option key={client.namecode} value={client.namecode}>{client.name}</option>
                                )}
                            </select>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label>Start Date:</label>
                        </Col>
                        <Col xs={9}>
                            <DatePicker dateFormat="dd/MM/yyyy" className="form-control" selected={new Date(this.state.startDate)}
                                onChange={date => this.setState({ startDate: date })}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"  
                                popperPlacement="bottom-start"
                                popperModifiers={{
                                    flip: {
                                        behavior: ["bottom"] 
                                    },
                                    preventOverflow: {
                                        enabled: false
                                    },
                                    hide: {
                                        enabled: false 
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label>End Date:</label>
                        </Col>
                        <Col xs={9}>
                            <DatePicker dateFormat="dd/MM/yyyy" className="form-control"  selected={new Date(this.state.endDate)} onChange={date => this.setState({ endDate: date })}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="bottom-start"
                                popperModifiers={{
                                    flip: {
                                        behavior: ["bottom"]
                                    },
                                    preventOverflow: {
                                        enabled: false
                                    },
                                    hide: {
                                        enabled: false
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <button type="button" className="btn btn-primary col-12" onClick={() => this.loadTransferDetails()}>
                                Load Transfers
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {rfTransfers}
                            </div>
                        </Col>
                    </Row>

                </Container>
                {displayTransferLinesPrompt }
            </div>
        );
    }
}